import React from 'react';

import Button, { SPINNER_ICON } from 'js/src/components/common/ui/Button';

type Props = {
    onClick: () => void;
    isUploading?: boolean;
};
const UploadRecordingButton: React.FC<Props> = ({ onClick, isUploading = false }) => {
    return (
        <Button
            text="Finish recording"
            iconLeft={isUploading ? SPINNER_ICON : 'done'}
            onClick={onClick}
            disabled={isUploading}
        />
    );
};
export default React.memo(UploadRecordingButton);
